import {
  Box,
  Card,
  CardActions,
  CardContent,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import "./SuppliesEntities.scss";
import { useNavigate } from "react-router-dom";
import TotalEnergiesContext from "../../core/store/context/TotalEnergiesContext";
import { FormattedOwnerData } from "../../core/models/ownerData/ownerData.model";
import { formatNumber } from "../../utils/formatters/formatters.util";

function SuppliesEntities() {
  // Translation
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { ownerData } = useContext(TotalEnergiesContext);

  // Set data
  const [userType, setUserType] = useState("");
  const [suppliesEntities, setSuppliesEntities] = useState({
    suppliesNumber: "",
    entitiesNumber: "",
  });

  useEffect(() => {
    getFormattedOwnerData(ownerData);
  }, [ownerData]);

  const getFormattedOwnerData = (ownerData: FormattedOwnerData | null) => {
    // Set Entities and Supplies
    if (ownerData) {
      const { isAdministrator, entitiesNumber, supplyNumber } = ownerData;

      if (isAdministrator) {
        setUserType("multicif");
      }

      setSuppliesEntities({
        suppliesNumber: supplyNumber,
        entitiesNumber: entitiesNumber!,
      });
    }
  };

  return (
    <>
      <Grid
        container
        columnSpacing={{ xs: 0, md: "20px" }}
        rowSpacing={{ xs: 2, md: 0 }}
        className="entities-supplies"
        sx={{ paddingTop: 5 }}
      >
        <Grid item xs={12} md={6}>
          <Card
            className="entities-supplies__card"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: 0,
              }}
            >
              <Box>
                <Typography
                  className="entities-supplies-title"
                  variant="subtitle1"
                  component="p"
                >
                  {t("Puntos de suministro.Título")}
                </Typography>
                <Typography
                  className="entities-supplies-qty"
                  variant="h1"
                  id="supplies"
                >
                  {suppliesEntities.suppliesNumber === ""
                    ? "0"
                    : formatNumber(+suppliesEntities.suppliesNumber)}
                </Typography>
              </Box>
              <Typography
                component="span"
                className="entities-supplies-icon t-icon-Gaz-and-Electricity"
                aria-hidden="true"
                sx={{ fontSize: "64px", lineHeight: "initial" }}
              />
            </CardContent>
            <CardActions sx={{ padding: 0 }}>
              <Link
                onClick={() => navigate(process.env.REACT_APP_SUPPLIES!)}
                className="entities-supplies-link"
                component="button"
                underline="none"
                variant="button"
              >
                {t("Puntos de suministro.Título")}
                <Typography
                  component="span"
                  className="t-icon-long-arrow-right"
                  aria-hidden="true"
                  sx={{ marginLeft: "10px" }}
                />
              </Link>
            </CardActions>
          </Card>
        </Grid>

        {userType && (
          <Grid item xs={12} md={6}>
            <Card
              className="entities-supplies__card"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: 0,
                }}
              >
                <Box>
                  <Typography
                    className="entities-supplies-title"
                    variant="subtitle1"
                    component="p"
                  >
                    {t("Entidades.Título")}
                  </Typography>
                  <Typography
                    className="entities-supplies-qty"
                    variant="h1"
                    id="entities"
                  >
                    {suppliesEntities.entitiesNumber === ""
                      ? "0"
                      : formatNumber(+suppliesEntities.entitiesNumber)}
                  </Typography>
                </Box>
                <Typography
                  component="span"
                  className="entities-supplies-icon t-icon-building2"
                  aria-hidden="true"
                  sx={{ fontSize: "64px", lineHeight: "initial" }}
                />
              </CardContent>
              <CardActions sx={{ padding: 0 }}>
                {/* <Link 
                                    className="entities-supplies-link" 
                                    component="button"
                                    underline="none"
                                    variant="button"
                                >
                                    {t("Entidades.Título")}
                                    <Typography component="span" className="t-icon-long-arrow-right" aria-hidden="true" sx={{marginLeft: '10px'}}/>
                                </Link> */}
              </CardActions>
            </Card>
          </Grid>
        )}
      </Grid>
      {/* <Stack className="entities-supplies" sx={{display: 'flex', flexDirection: {md:'row', xs:'column'}, paddingTop: 5}}>
                <Card className="entities-supplies__card" sx={{display: 'flex', justifyContent:'space-between', flexDirection: 'column'}}>
                    <CardContent sx={{display: 'flex', justifyContent:'space-between',  padding: 0}}>
                        <Box>
                            <Typography className="entities-supplies-title" variant="subtitle1" component="p">{t("Puntos de suministro.Título")}</Typography>
                            <Typography className="entities-supplies-qty" variant="h1" id="supplies">{suppliesEntities.suppliesNumber === "" ? "0" : suppliesEntities.suppliesNumber}</Typography>
                        </Box>
                        <Typography component="span" className="entities-supplies-icon t-icon-Gaz-and-Electricity" aria-hidden="true" sx={{fontSize:'64px', lineHeight: 'initial'}} />
                    </CardContent>
                    <CardActions sx={{ padding: 0}}>
                        <Link 
                            className="entities-supplies-link" 
                            component="button"
                            underline="none"
                            variant="button"
                        >
                            {t("Puntos de suministro.Título")} 
                            <Typography component="span" className="t-icon-long-arrow-right" aria-hidden="true" sx={{marginLeft: '10px'}} />
                        </Link>
                    </CardActions>
                </Card>

                {userType && (
                    <Card className="entities-supplies__card" sx={{display: 'flex', justifyContent:'space-between', flexDirection: 'column'}}>
                        <CardContent sx={{display: 'flex', justifyContent:'space-between', padding: 0}}>
                            <Box>
                                <Typography className="entities-supplies-title" variant="subtitle1" component="p">{t("Entidades.Título")}</Typography>
                                <Typography className="entities-supplies-qty" variant="h1" id="entities">{suppliesEntities.entitiesNumber === "" ? "0" : suppliesEntities.entitiesNumber}</Typography>
                            </Box>
                            <Typography component="span" className="entities-supplies-icon t-icon-building2" aria-hidden="true" sx={{fontSize:'64px', lineHeight: 'initial'}} />
                        </CardContent>
                        <CardActions sx={{ padding: 0}}>
                            <Link 
                                className="entities-supplies-link" 
                                component="button"
                                underline="none"
                                variant="button"
                            >
                                {t("Entidades.Título")}
                                <Typography component="span" className="t-icon-long-arrow-right" aria-hidden="true" sx={{marginLeft: '10px'}}/>
                            </Link>
                        </CardActions>
                    </Card>
                )}
            </Stack> */}
    </>
  );
}

export default SuppliesEntities;
